module.exports = __webpack_public_path__ + "img/attack_evil_pillar.5e0df236.png";